<template>
  <div class="astro-dialog-container">
    <div
      v-if="isMobile"
      class="AstroCalendarFullNotice-mobile"
      @mousemove="handleMove"
      @touchmove="handleMove"
      @mouseup="handleEnd"
      @touchend="handleEnd"
      @mouseleave="handleEnd"
    >
      <div class="content-layer" :style="contentStyle">
        <div class="inner-layout">
          <div class="astroCalendarNoticeDialog__box">
            <div class="astroCalendarNoticeDialog__box__picArea">
              <img :src="topicImg" alt="" />
            </div>

            <div class="astroCalendarNoticeDialog__box__date">
              {{ todayDate }} <span>{{ moment().format("ddd") }}</span>
            </div>

            <div class="astroCalendarNoticeDialog__box__title">
              ★ {{ calendarInterpretation && calendarInterpretation.Highlight }}
            </div>

            <div class="astroCalendarNoticeDialog__box__teacher">
              <div class="teacher__header">
                <div class="teacher__header__pic">
                  <img src="../../../cn-demo-assets//Logo.png" alt="" />
                </div>
                <div class="teacher__header__title">星学会的一句叮咛</div>
              </div>
              <div class="teacher__content">
                {{ calendarInterpretation && calendarInterpretation.Remind }}
              </div>
            </div>

            <div
              class="astroCalendarNoticeDialog__box__btn"
              @click="toCalendar"
            >
              前往共时历
            </div>
            <div
              class="astroCalendarNoticeDialog__box__textBtn"
              @click="toAstrolabe"
            >
              探索星盘
            </div>
          </div>
        </div>
      </div>

      <div
        class="curl-layer"
        :class="{ animating: isAnimating }"
        :style="curlStyle"
      ></div>

      <div
        class="trigger-zone"
        @mousedown.stop="handleStart"
        @touchstart.stop="handleStart"
      ></div>
    </div>

    <transition name="fade" v-else>
      <Fixed_popup class="astroCalendarNoticeDialog">
        <div class="astroCalendarNoticeDialog__box">
          <div class="astroCalendarNoticeDialog__box__picArea">
            <img :src="topicImg" alt="" />
          </div>

          <div class="astroCalendarNoticeDialog__box__date">
            {{ todayDate }} <span>{{ moment().format("ddd") }}</span>
          </div>

          <div class="astroCalendarNoticeDialog__box__title">
            ★ {{ calendarInterpretation && calendarInterpretation.Highlight }}
          </div>

          <div class="astroCalendarNoticeDialog__box__teacher">
            <div class="teacher__header">
              <div class="teacher__header__pic">
                <img src="../../../cn-demo-assets/Logo.png" alt="" />
              </div>
              <div class="teacher__header__title">星学会的一句叮咛</div>
            </div>
            <div class="teacher__content">
              {{ calendarInterpretation && calendarInterpretation.Remind }}
            </div>
          </div>

          <div class="astroCalendarNoticeDialog__box__btn" @click="toCalendar">
            前往共时历
          </div>
          <div
            class="astroCalendarNoticeDialog__box__textBtn"
            @click="toAstrolabe"
          >
            探索星盘
          </div>
        </div>
      </Fixed_popup>
    </transition>
  </div>
</template>

<script>
import Fixed_popup from "@/components/Fixed_popup.vue";
import moment from "moment";

export default {
  name: "AstroCalendarNoticeDialog",
  components: { Fixed_popup },
  data() {
    return {
      // --- 共用與資料邏輯 ---
      isMobile: false,
      todayDayOfWeek: moment().format("dddd"),
      todayDate: moment().format("MM/DD"),
      constellation: [
        { name: "牡羊", img: require("@/assets/constellations/con_1.svg") },
        { name: "金牛", img: require("@/assets/constellations/con_2.svg") },
        { name: "雙子", img: require("@/assets/constellations/con_3.svg") },
        { name: "巨蟹", img: require("@/assets/constellations/con_4.svg") },
        { name: "獅子", img: require("@/assets/constellations/con_5.svg") },
        { name: "處女", img: require("@/assets/constellations/con_6.svg") },
        { name: "天秤", img: require("@/assets/constellations/con_7.svg") },
        { name: "天蠍", img: require("@/assets/constellations/con_8.svg") },
        { name: "射手", img: require("@/assets/constellations/con_9.svg") },
        { name: "摩羯", img: require("@/assets/constellations/con_10.svg") },
        { name: "水瓶", img: require("@/assets/constellations/con_11.svg") },
        { name: "雙魚", img: require("@/assets/constellations/con_12.svg") },
      ],
      mockTitle: "月亮處女 / 服務精神",

      // --- 手機版翻頁邏輯變數 ---
      isDragging: false,
      peelSize: 0,
      windowWidth: 0,
      windowHeight: 0,
      isAnimating: false,
    };
  },
  computed: {
    calendarInterpretation() {
      return this.$store.state.calendarInterpretation || {};
    },
    topicImg() {
      if (
        !this.calendarInterpretation ||
        !this.calendarInterpretation.Highlight
      ) {
        return require("@/assets/constellations/con_1.svg");
      }
      let target = this.constellation.find((item) =>
        this.calendarInterpretation.Highlight.includes(item.name)
      );
      return target ? target.img : require("@/assets/constellations/con_1.svg");
    },
    // --- 手機版 Style ---
    contentStyle() {
      const size = this.peelSize;
      return {
        clipPath: `polygon(
            0 0, 
            100% 0, 
            100% calc(100% - ${size}px), 
            calc(100% - ${size}px) 100%, 
            0 100%
          )`,
        transition: this.isAnimating
          ? "clip-path 0.5s cubic-bezier(0.25, 1, 0.5, 1)"
          : "none",
      };
    },
    curlStyle() {
      const size = this.peelSize;
      return {
        width: `${size}px`,
        height: `${size}px`,
        transition: this.isAnimating
          ? "width 0.5s cubic-bezier(0.25, 1, 0.5, 1), height 0.5s cubic-bezier(0.25, 1, 0.5, 1)"
          : "none",
      };
    },
  },
  mounted() {
    const today = moment().format("YYYY-MM-DD");
    localStorage.setItem("astroCalendarNotice", today);

    this.updateDims();
    window.addEventListener("resize", this.updateDims);

    // 手機版初始稍微翹起一點
    this.peelSize = 80;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateDims);
  },
  methods: {
    moment,
    updateDims() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      this.isMobile = this.windowWidth <= 576;
    },
    toCalendar() {
      this.$router.push("/astroCalendar");
      this.$emit("close");
    },
    toAstrolabe() {
      this.$router.push("/astrolabe");
      this.$emit("close");
    },
    // --- 手機版翻頁控制 ---
    handleStart() {
      if (!this.isMobile) return;
      this.isDragging = true;
      this.isAnimating = false;
    },
    handleMove(e) {
      if (!this.isDragging || !this.isMobile) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const distRight = this.windowWidth - clientX;
      const distBottom = this.windowHeight - clientY;
      if (distRight < 0 || distBottom < 0) return;
      this.peelSize = Math.max(distRight, distBottom);
    },
    handleEnd() {
      if (!this.isDragging || !this.isMobile) return;
      this.isDragging = false;
      this.isAnimating = true;

      const threshold = this.windowWidth * 0.8;
      if (this.peelSize > threshold) {
        // 撕開成功 -> 放大並關閉
        const maxSize = Math.max(this.windowWidth, this.windowHeight) * 2.5;
        this.peelSize = maxSize;
        setTimeout(() => {
          this.$emit("close");
        }, 500);
      } else {
        // 復原
        this.peelSize = 80;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_mixin.scss";

// ----------------------------------------------------------------
// 1. 共用樣式 & 電腦版主體
//    手機版透過 @include mobile 改寫尺寸
// ----------------------------------------------------------------
.astroCalendarNoticeDialog {
  .popup-mask-container {
    // 為了讓翻頁效果滿版，這裡可能需要重置 padding
    @include mobile {
      padding: 0;
    }
  }
}

.astroCalendarNoticeDialog__box {
  z-index: 1050;
  margin: auto;
  // 電腦版預設
  @include rect(520px, auto, $theme-color-3, 50px);
  @include center;
  flex-direction: column;
  padding: 40px 36px 40px;
  transition: 0.5s;

  // -------------------------------------
  // 手機版樣式覆寫 (內容結構一樣，但外觀滿版)
  // -------------------------------------
  @include mobile() {
    // 在手機版翻頁層內，我們希望它充滿容器 (100vh/vw) 或者是滿版卡片
    // 這裡設為 100% 配合外層的 content-layer
    width: 100vw;
    height: 100vh;
    height: 100svh;
    border-radius: 0; // 手機版像一張紙，不用圓角
    margin: 0;
    padding: 28px;
    justify-content: center; // 垂直居中
  }

  &__picArea {
    width: 120px;
    height: 120px;
    box-shadow: 4.75px 4.75px 11.88px 0px #00000033,
      -2.38px -2.38px 4.75px 0px rgba(238, 109, 175, 0.22), -2.38px -2.38px 4.75px 0px rgba(238, 109, 175, 0.22);

    border-radius: 50%;
    margin-bottom: 16px;
    @include center;
    img {
      height: 80px;
      width: 80px;
      object-fit: cover;
      margin: 0 auto;
    }
    // 手機版微調
    @include mobile {
      width: 76px;
      height: 76px;
      img {
        width: 50px;
        height: 50px;
      }
    }
  }

  &__date {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    color: $secondary-color-1;
    margin-bottom: 4px;
    span {
      font-size: 16px;
    }
    @include mobile {
      font-size: 20px;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
    color: $secondary-color-1;

    @include mobile {
      font-size: 20px;
      line-height: 28px;
    }
  }

  &__teacher {
    width: 100%;
    margin-top: 32px;
    margin-bottom: 20px;
    .teacher__header {
      display: flex;
      align-items: center;
      .teacher__header__pic {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 12px;
        @include mobile {
          width: 32px;
          height: 32px;
          margin-right: 8px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .teacher__header__title {
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        color: #ab956c;
        @include mobile {
          font-size: 14px;
        }
      }
    }
    .teacher__content {
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      color: #868686;
      margin-top: 4px;
      text-align: left;
      // 手機版字體可能要大一點或行高調整
      @include mobile {
        font-size: 15px;
        line-height: 1.6;
      }
    }
  }

  &__btn {
    @include btn(245px, 44px, $theme-color-1, $theme-color-3, 20px);
    margin-top: 40px;
    transition: 0.2s;
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;

    @include mobile() {
      // 手機版按鈕微調
      @include btn(220px, 44px, $theme-color-1, $theme-color-3, 22px);
      margin-top: 50px;
      font-size: 15px;
    }

    &:hover {
      opacity: 0.7;
    }
    &:active {
      background-color: $secondary-color-1;
    }
  }

  &__textBtn {
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
    color: $theme-color-1;
    margin-top: 16px;
    cursor: pointer;

    @include mobile {
      font-size: 14px;
      margin-top: 20px;
    }
  }
}

// ----------------------------------------------------------------
// 2. Mobile Peel Wrapper Style (功能性樣式，不負責內容外觀)
// ----------------------------------------------------------------
@include mobile {
  .AstroCalendarFullNotice-mobile {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: 100svh;
    z-index: 9999;
    overflow: hidden;
    background: transparent; // 背景透明

    // 禁止選取與慣性捲動
    user-select: none;
    touch-action: none; // 避免瀏覽器預設滑動干擾

    .trigger-zone {
      position: absolute;
      bottom: 12px;
      right: 12px;
      bottom: calc(env(safe-area-inset-bottom) + 12px);
      right: calc(env(safe-area-inset-right) + 12px);
      width: 150px;
      height: 150px;
      z-index: 100;
      cursor: nw-resize;
    }

    .content-layer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // 這裡不需要設背景色，因為背景色由裡面的 astroCalendarNoticeDialog__box 負責
      // 但為了配合翻頁下的「底色」，通常建議給一個與 body 相同的背景
      background-color: #f2f4f6;

      .inner-layout {
        width: 100%;
        height: 100%;
        overflow: hidden; // 禁止溢出
      }
    }

    .curl-layer {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 50;
      pointer-events: none;
      box-shadow: -5px -5px 20px rgba(0, 0, 0, 0.3);
      // 翻頁背面的漸層
      background: linear-gradient(
        135deg,
        #8e9ba8 0%,
        #bdcdd9 35%,
        #eef4f8 45%,
        #bdcdd9 49%,
        transparent 50%
      );
    }
  }
}
</style>
